
























































































import { Prop, Component } from "vue-property-decorator";
import util from "@/lib/util";
import moment from "moment";
import { VcClaimLogDto, UpdateVcClaimLogInputDto } from "@/asdcom/apiproxy/apiproxy.dto";
import ClaimViewBaseComponent from "@/views/vcponlineok/staff-user/claim-view/ClaimViewBaseComponent";

@Component({})
export default class ClaimLogComponent extends ClaimViewBaseComponent {
  loading: boolean = false;
  reminderDate: string | undefined = "";
  requestApprovalStatuses = util.abp.constant.claimStatus.values;
  inputModel = new UpdateVcClaimLogInputDto();
  @Prop({default:() => {}}) data: VcClaimLogDto;

  created() {
    if (this.data.dueDate !== undefined) {
      this.reminderDate = moment(this.data.dueDate).format("YYYY-MM-DD");
    } else {
      this.reminderDate = "";
    }
  }

  get maxDate() {
    return moment().add(90, "days").format("YYYY-MM-DD");
  }

  get minDate() {
    return moment().format("YYYY-MM-DD");
  }

  async onSave() {
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        this.inputModel.claimNumber = this.vcClaimNumber;
        this.inputModel.claimLogId = this.data.id;
        this.inputModel.completeReminder = false;
        this.inputModel.dueDate = moment(this.reminderDate);
        this.$appsvs.vcpOnlineOkStaff.updateVcClaimReminderLogEntry(this.inputModel)
          .then((res: any) => {
            this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
            //  this.$appsvs.globalEventsService.reminderChanged();
            this.$emit('onClose');
          })
      } 
    })
  }

  onDeleteReminder() {
    this.inputModel.claimNumber = this.vcClaimNumber;
    this.inputModel.claimLogId = this.data.id;
    this.inputModel.completeReminder = true;
    this.inputModel.dueDate = undefined;
    this.$appsvs.vcpOnlineOkStaff.updateVcClaimReminderLogEntry(this.inputModel)
      .then((res: any) => {
        this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
        // this.$appsvs.globalEventsService.reminderChanged();
        this.reminderDate = "";
        this.$emit('onClose');
      })
  }
}
